import React from 'react';

const questions = {
  40000: (
    <>
      Now that those details are out of the way, let’s talk about what your
      program does — and its results.
    </>
  ),
  40002: <>What would you say is your program’s primary cause?</>,
  40003: <>Which Impact Model template best describes your program?</>,
  40004: <>Who or what does your program primarily help?</>,
  40005: <>How does your program achieve its goals?</>,
  40006: <>How does your program provide its services?</>,
};

interface QuestionsTextProps {
  defaultTitle: string;
  questionId: number;
}

const QuestionsText: React.FC<QuestionsTextProps> = ({
  questionId,
  defaultTitle,
}) => {
  return questions[questionId] || defaultTitle;
};

export default React.memo(QuestionsText);
